import React, { useMemo } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Button as MaterialButton } from '@material-ui/core';
import { theme } from '../../theme';
import { MAX_UINT, isApproved } from '../../utils/utils';
import useApprove from '../../hooks/useApprove';
import useAllowance from '../../hooks/useAllowance';

const StyledButton = withStyles({
    root: {
        background: theme.palette.gradient.main,
        borderRadius: 3,
        border: 0,
        color: theme.palette.text.primary,
        minHeight: 38,
        padding: '0 15px',
    },
    label: {
        textTransform: 'capitalize',
    },
})(MaterialButton);

const ApproveButton = ({ poolAddress, poolTokenAddress }) => {
    const allowance = useAllowance(poolAddress, poolTokenAddress);
    const { onApprove } = useApprove(poolAddress, poolTokenAddress);
    const isTokenApproved = useMemo(() => isApproved(allowance), [allowance]);

    const onApproveHandler = async () => {
        await onApprove();
    };

    return (
      <>
        {isTokenApproved
                ? (
                  <MaterialButton
                    size="small"
                    disabled
                    color="secondary"
                  >
                    Approved
                  </MaterialButton>
)
                : (
                  <StyledButton
                    size="small"
                    onClick={onApproveHandler}
                    disabled={false}
                    color="secondary"
                  >
                    Approve
                  </StyledButton>
)}

      </>
    );
};

export default ApproveButton;
